module.exports = __webpack_public_path__ + "assets/img/move-to-icon_new.444a2eee.svg";